/**
 * BadgeChip — renders a colored pill + lucide-react icon for a partner-tier
 * badge_id. Reads from the shared registry so admin UI + customer-facing
 * list look identical.
 *
 * Returns `null` when badge_id is "none" (or unknown) — caller doesn't have
 * to guard.
 */
import React from "react";
import { badgeMeta, badgeColorClasses, badgeIconComponent } from "@/lib/badge_presets";
import { cn } from "@/lib/utils";

export default function BadgeChip({ badgeId, size = "sm", className, testId }) {
  const meta = badgeMeta(badgeId);
  if (!meta || !meta.label) return null;
  const Icon = badgeIconComponent(meta.icon);
  const color = badgeColorClasses(meta.color);
  const sz =
    size === "xs"
      ? "px-2 py-0.5 text-[10px] gap-1"
      : size === "md"
      ? "px-3 py-1 text-sm gap-1.5"
      : "px-2.5 py-0.5 text-xs gap-1";
  const iconSize = size === "md" ? "h-3.5 w-3.5" : "h-3 w-3";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold",
        color,
        sz,
        className
      )}
      data-testid={testId}
    >
      {Icon && <Icon className={iconSize} />}
      <span>{meta.label}</span>
    </span>
  );
}
